
<div class="outer-div" style="background: white;height:88vh;">
  <!-- #307b7505; -->
 <div style="margin-top: 0.5%;margin-bottom: 0.5%;display: flex;gap: 1%;">
    
<p class="glow-text">Welcome back, {{userName}} <span class="wave-hand">✋</span></p>

<span class="example-spacer"></span>
          <div class="calendar-wrapper">
              <!-- <p-calendar 
              appendTo="body"
        [(ngModel)]="rangeDates" 
        selectionMode="range" 
        [readonlyInput]="true" 
        ></p-calendar> -->
        <mat-form-field appearance="outline" class="date-range-field">
          <!-- <mat-label>Date Range</mat-label> -->
          <mat-date-range-input [rangePicker]="picker">
            <input matStartDate [(ngModel)]="rangeStartDate" (dateChange)="onDateRangeChange()" placeholder="Start date" readonly>
            <input matEndDate [(ngModel)]="rangeEndDate" (dateChange)="onDateRangeChange()" placeholder="End date" readonly>
          </mat-date-range-input>
          <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
          <mat-date-range-picker #picker></mat-date-range-picker>
        </mat-form-field>
    </div>
    <p-select
      [options]="productOptions"
      optionLabel="label"
      placeholder="Product"
       [filter]="true"
         panelStyleClass="custom-pselect-panel"
         appendTo="body"
      class="filter-dd"
      (onChange)="onProductFilter($event.value)">
    </p-select>
     <p-select
      [options]="dataSourceOptions"
      optionLabel="label"
       [filter]="true"
      placeholder="Data Source"
      appendTo="body"
        panelStyleClass="custom-pselect-panel"
      class="filter-dd"
      (onChange)="onDataSourceFilter($event.value)">
    </p-select>
    <!-- <i class="pi pi-filter" style="color: slateblue"></i>
    <mat-icon class="close-icon" style="cursor: unset;">filter_list</mat-icon> -->
    <!-- <app-common-button
    
         class="AdBtn"
          label="Advance Filter"
          title="Advance Filter"
          icon="fas fa-filter"
          width="auto"
          [buttonId]="1111"
          variant="cancel"
          padding="0px 5px"
          [critical]="false"
          (click)="openAdvanceFilters()"
          >
          </app-common-button> -->
    </div>
    <div style="display:flex; gap:16px;">
  

  <div style="width:30%; height:250px; background:white; border:1px solid #ccc; border-radius:8px; padding:12px; overflow:hidden;">
    <P style="font-weight: 600;">Alert Summary</P>
    <app-reusable-apex-chart [options]="donutChartOptions"></app-reusable-apex-chart>
  </div>
   <div style="width:30%; height:250px; background:white; border:1px solid #ccc; border-radius:8px; padding:12px; overflow:hidden;">
    <P style="font-weight: 600;">Signal By Products</P>
    <app-reusable-apex-chart [options]="pieChartOptions"></app-reusable-apex-chart>
  </div>
   <div style="width:40%; height:250px; background:white; border:1px solid #ccc; border-radius:8px; padding:12px; overflow:hidden;">
    <!-- <P style="font-weight: 600;">Review Activites</P> -->
    <app-reusable-apex-chart [options]="barChartOptions"></app-reusable-apex-chart>
  </div>
  <!-- <div style="width:500px; height:300px; background:white; border:1px solid #ccc; border-radius:8px; padding:12px; overflow:hidden;">
    <app-reusable-apex-chart [options]="barChartOptions"></app-reusable-apex-chart>
  </div> -->
</div>
<div style="display:flex; gap:16px;margin-top: 2%;">
 <div style="width:30%; height:250px;background:white; border:1px solid #ccc; border-radius:8px; padding:12px; overflow:hidden;">
    <!-- <P style="font-weight: 600;">Signal Summary</P> -->
    <app-reusable-apex-chart  [options]="funnelChartOptions"></app-reusable-apex-chart>
  </div>
    <div style="width:30%; height:250px; background:white; border:1px solid #ccc; border-radius:8px; padding:12px; overflow:hidden;">
    <P style="font-weight: 600;"> Signal Originated From Primary Sources</P>
    <app-reusable-apex-chart [options]="SignaloriginatedChartOptions"></app-reusable-apex-chart>
  </div>
  <div style="width:40%; height:250px; background:white; border:1px solid #ccc; border-radius:8px; padding:12px; overflow:hidden;">
    <!-- <P style="font-weight: 600;">Products Lifecycle State</P> -->
    <app-reusable-apex-chart [options]="productsChartOptions"></app-reusable-apex-chart>
  </div>
</div>




<div style="display:flex; gap:16px;margin-top: 2%;margin-bottom: 2%;">
 <div style="width:60%; height:250px; background:white; border:1px solid #ccc; border-radius:8px; padding:12px; overflow:hidden;">
    <P style="font-weight: 600;margin-bottom: 8px;">Activites For You</P>
    <div style=" height:200px;overflow: auto;">
      <ul class="custom-list" style="list-style: none;
    padding: 0;">
        <li *ngFor="let item of reviewActivitiesList">
        
      <P  *ngIf="item.scheduleState =='In Review'"  style="font-size: 14px;
    font-weight: 500;">
    <span *ngIf="item.isOverdue" class="badge overdue"title="Overdue"><span class="glow-icon">🚨</span>Overdue</span>
   <!-- scheduleState -->
    <span *ngIf="!item.isOverdue && item.scheduleState =='In Review'" class="badge inReview"title="In Review"><span class="glow-icon">
🔍</span>In Review</span>

    <span class="activity-text">
      <strong *ngIf="item.productName">Product:</strong> <span  *ngIf="item.productName" style="color: #0052cc;
    margin: 0 4px;">{{item.productName}}</span>  
      <span  *ngIf="item.productName" class="divider-line"></span>
      <strong>PSS:</strong> <span style="color: #0052cc;
    margin: 0 4px;">{{item.pssName}}</span> 
    <!-- with  -->
     <span class="divider-line"></span>
    <strong>Activity:</strong>
    <span style="color: #0052cc;
    margin: 0 4px;">{{item.activityName}}</span>
    <span *ngIf="item.isOverdue">
    <span style="color: #d32f2f;
    margin: 0 4px;text-shadow: 0 0 4px rgba(255, 0, 0, 0.4);font-weight: 600;">{{calculateDays(item.activityDueDate)}} Days</span> overdue</span>
    </span>
    <mat-icon class="link-icon">open_in_new</mat-icon>
    </P>
        </li>
      </ul>
    </div>
  </div>
   <div style="width:39%; height:250px; background:white; border:1px solid #ccc; border-radius:8px; padding:12px; overflow:hidden;">
    <!-- <P style="font-weight: 600;"> <span class="mat-button-wrapper"><svg viewBox="0 0 24 24" width="24px" height="24px" fill="currentColor" focusable="false" class="mat-datepicker-toggle-default-icon ng-star-inserted"><path d="M19 3h-1V1h-2v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V8h14v11zM7 10h5v5H7z"></path></svg></span> Meetings</P> -->
    <!-- <div class="meetings-card">
  <div class="meetings-header">
    <div class="meetings-title-wrap">
      <mat-icon class="meetings-icon">event</mat-icon>
      <div>
        <div class="meetings-title">Meetings</div>
        <div class="meetings-subtitle">Today</div>
      </div>
    </div>

    <span class="meeting-count">3</span>
  </div>

  <div class="meetings-list">
    <div class="meeting-row current">
      <div class="meeting-time">
        <div class="time-main">10:30 AM</div>
        <div class="time-range">10:30 - 11:00</div>
      </div>

      <div class="meeting-details">
        <div class="meeting-top">
          <span class="meeting-name">Daily Review Sync</span>
          <span class="meeting-status now">Now</span>
        </div>
        <div class="meeting-meta">
          Product Safety Team
          <span class="meta-divider"></span>
          Google Meet
        </div>
      </div>

      <button mat-icon-button class="open-btn" matTooltip="Open meeting link">
        <mat-icon>open_in_new</mat-icon>
      </button>
    </div>

    <div class="meeting-row upcoming">
      <div class="meeting-time">
        <div class="time-main">1:00 PM</div>
        <div class="time-range">1:00 - 1:45</div>
      </div>

      <div class="meeting-details">
        <div class="meeting-top">
          <span class="meeting-name">Client Discussion</span>
          <span class="meeting-status upcoming">Upcoming</span>
        </div>
        <div class="meeting-meta">
          Crocin Project
          <span class="meta-divider"></span>
          Teams Meeting
        </div>
      </div>

      <button mat-icon-button class="open-btn" matTooltip="Open meeting link">
        <mat-icon>open_in_new</mat-icon>
      </button>
    </div>

    <div class="meeting-row completed">
      <div class="meeting-time">
        <div class="time-main">9:00 AM</div>
        <div class="time-range">9:00 - 9:30</div>
      </div>

      <div class="meeting-details">
        <div class="meeting-top">
          <span class="meeting-name">Planning Call</span>
          <span class="meeting-status completed">Completed</span>
        </div>
        <div class="meeting-meta">
          Internal Team
          <span class="meta-divider"></span>
          Conference Room 2
        </div>
      </div>

      <button mat-icon-button class="open-btn" matTooltip="Open details">
        <mat-icon>open_in_new</mat-icon>
      </button>
    </div>
  </div>
</div> -->
<div class="dashboard-card card-sm">
  <div class="meetings-card">
    <div class="meetings-header">
      <mat-icon class="meetings-icon">event</mat-icon>
      <div>
        <div class="meetings-title">Meetings</div>
        <div class="meetings-subtitle">Today</div>
      </div>
    </div>

    <div class="meetings-list">
      <div *ngFor="let meeting of meetingsList"
           class="meeting-row" 
           [ngClass]="getMeetingStatus(meeting)">

        <div class="meeting-time">
          <div class="time-main">
            {{ formatTime(meeting.meetingStartTime) }}
          </div>
          <div class="time-range">
            {{ formatTime(meeting.meetingStartTime) }} - {{ formatTime(meeting.meetingEndTime) }}
          </div>
        </div>

        <div class="meeting-details">
          <div class="meeting-top">
            <span class="meeting-name">{{ meeting.meetingSubject }}</span>

            <span class="meeting-status"
                  [ngClass]="getMeetingStatus(meeting)">
              {{ getMeetingStatus(meeting) | titlecase }}
            </span>
          </div>

          <div class="meeting-meta">
            {{ meeting.isRecurring ? 'Recurring' : 'One-time' }}
            <span class="meta-divider"></span>
            {{ meeting.participantCount }} participants
          </div>
        </div>

        <button mat-icon-button
                class="open-btn"
                (click)="openMeeting(meeting.meetingLink)">
          <mat-icon>open_in_new</mat-icon>
        </button>
      </div>
    </div>
  </div>
</div>
  </div>
  
  </div>
 
<!-- <div class="chart-card">
  <app-reusable-apex-chart [options]="barChartOptions"></app-reusable-apex-chart>
</div> -->
</div>
